import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type FlexibleDiscountDataFragment = (
  { __typename: 'FlexibleDiscount' }
  & Pick<SchemaTypes.FlexibleDiscount, 'isEnabled'>
);

export const FlexibleDiscountDataFragmentDoc = /*#__PURE__*/ gql`
    fragment FlexibleDiscountData on FlexibleDiscount {
  isEnabled
}
    `;